import React, { useEffect, useState } from 'react';
import './page.css';
import './table.css';
import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';
import { resolveDate } from '../../../../configs/helpers/utility';

const useStyles = makeStyles((theme) => ({
   graphsContainer: {
      width: '100%',
      display: 'flex',
   },
}));

const PDFCSS = () => {
   const classes = useStyles();
   const [totalPoint, setTotalPoint] = useState();
   const [filtersData, setFiltersData] = useState();
   const [chartData, setChartData] = useState();
   useEffect(() => {
      let report = localStorage.getItem('report');
      if (report) {
         let { totalPoint, filtersData, chartData } = JSON.parse(report);
         setTotalPoint(totalPoint);
         setFiltersData(filtersData);
         setChartData(chartData);
         window.print();
      }
      return () => {
         localStorage.removeItem('report');
      };
   }, []);
   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };
   const getChartsOptionsDefault = () => {
      return {
         animation: false,
         animationDuration: 0,
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               type: 'shadow',
            },
         },
         legend: {},
         grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: [
            {
               type: 'category',
               axisLabel: { rotate: 90 },
               data: null,
            },
         ],
         yAxis: [
            {
               name: 'คะแนน',
               type: 'value',
            },
         ],
         series: [
            {
               color: '#F383BB',
               name: 'จำนวนคะแนน G',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#633C21',
               name: 'จำนวนคะแนน S',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               color: '#EDD221',
               name: 'จำนวนคะแนน B',
               type: 'bar',
               stack: 'GSB',
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
         ],
      };
   };
   const mapOptions = (data) => {
      let xAxisData = data.map((el) => el.groupName);
      let G = data.map((el) => el.gTotalPoints);
      let S = data.map((el) => el.sTotalPoints);
      let B = data.map((el) => el.bTotalPoints);
      let options = getChartsOptionsDefault();
      options.xAxis[0].data = xAxisData;
      options.series[0].data = G;
      options.series[1].data = S;
      options.series[2].data = B;
      return options;
   };
   const showMultiple = (list, key) => {
      return list.map((el, index) => (
         <div>
            {el.data.shortName}
            {index !== list.length - 1 ? ',' : ''}
         </div>
      ));
   };
   return (
      <div className='book'>
         <div className='page' id='1'>
            <div className='subpage'>
               <div className='title'>แสดงคะแนนกิจกรรมแบ่งตามสังกัด</div>
               <div className='sub-title'>สรุปการใช้คะแนน</div>
               <div className='content'>
                  ปี : {totalPoint && totalPoint.year}
                  <table className='normal'>
                     <tr>
                        <th>ประเภท</th>
                        <th>คะแนนทั้งหมด</th>
                        <th>ใช้ไป P</th>
                        <th>ใช้ไป GSB Way of Work</th>
                        <th>ใช้ไปหลักเกณฑ์</th>
                        <th>คงเหลือ</th>
                        <th>อัพเดทล่าสุดเมื่อ</th>
                     </tr>
                     {totalPoint && totalPoint.hrPoints && (
                        <tr>
                           <td>HR</td>
                           <td class='text-right'>
                              {costFormat(totalPoint.hrPoints.totalReceived)}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalBankWalletUsed,
                              )}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalEmployeeUsed,
                              )}
                           </td>
                           <td class='text-right'>
                              {costFormat(totalPoint.hrPoints.totalRuleUsed)}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalRemainingPoints,
                              )}
                           </td>
                           <td>{totalPoint.hrPoints.updateTimeLabel}</td>
                        </tr>
                     )}
                  </table>
                  <table className='normal' style={{ marginTop: '10px' }}>
                     <tr>
                        <th>ประเภท</th>
                        <th>คะแนนทั้งหมด</th>
                        <th>ใช้ไป</th>
                        <th>คงเหลือ</th>
                        <th>อัพเดทล่าสุดเมื่อ</th>
                     </tr>
                     {totalPoint &&
                        totalPoint.allPoints &&
                        totalPoint.allPoints
                           .filter((item) =>
                              ['B', 'G', 'S'].includes(item.currency),
                           )
                           .sort((a, b) => {
                              const order = { B: 0, G: 1, S: 2 };
                              return order[a.currency] - order[b.currency];
                           })
                           .map((item, index) => {
                              const currencyTextMap = {
                                 G: 'with GOVERNANCE',
                                 S: 'through DIGITALIZATION',
                                 B: 'for SOCIETY',
                              };
                              const displayCurrency =
                                 currencyTextMap[item.currency] ||
                                 item.currency;

                              return (
                                 <tr key={index}>
                                    <td>{displayCurrency}</td>
                                    <td class='text-right'>
                                       {costFormat(item.totalReceived)}
                                    </td>
                                    <td class='text-right'>
                                       {costFormat(item.totalRedeem)}
                                    </td>
                                    <td class='text-right'>
                                       {costFormat(item.totalRemainingPoints)}
                                    </td>
                                    <td>{item.updateTimeLabel}</td>
                                 </tr>
                              );
                           })}
                  </table>
               </div>
               <div className='sub-title'>ตัวกรอง</div>
               <div>
                  <div>
                     กิจกรรม:&nbsp;
                     {(filtersData &&
                        filtersData.activity &&
                        filtersData.activity.activityNameTh) ||
                        '-'}
                  </div>
                  <div style={{ display: 'flex' }}>
                     กลุ่ม:&nbsp;
                     {(filtersData &&
                        filtersData.group &&
                        showMultiple(filtersData.group, 'group')) ||
                        '-'}
                  </div>
                  <div style={{ display: 'flex' }}>
                     สายงาน:&nbsp;
                     {(filtersData &&
                        filtersData.field &&
                        showMultiple(filtersData.field, 'field')) ||
                        '-'}
                  </div>
                  <div style={{ display: 'flex' }}>
                     ฝ่าย/ภาค:&nbsp;
                     {(filtersData &&
                        filtersData.department &&
                        showMultiple(filtersData.department, 'department')) ||
                        '-'}
                  </div>
                  <div style={{ display: 'flex' }}>
                     ส่วน/เขต:&nbsp;
                     {(filtersData &&
                        filtersData.segment &&
                        showMultiple(filtersData.segment, 'segment')) ||
                        '-'}
                  </div>
                  <div style={{ display: 'flex' }}>
                     งาน/สาขา:&nbsp;
                     {(filtersData &&
                        filtersData.branch &&
                        showMultiple(filtersData.branch, 'branch')) ||
                        '-'}
                  </div>
                  <div>
                     เริ่มต้น:{' '}
                     {(filtersData &&
                        resolveDate(filtersData.startDateString)) ||
                        '-'}
                  </div>
                  <div>
                     สิ้นสุด:{' '}
                     {(filtersData && resolveDate(filtersData.endDateString)) ||
                        '-'}
                  </div>
               </div>
               <div className='sub-title'>กราฟ</div>
               <div className={classes.graphsContainer}>
                  {chartData && (
                     <ReactECharts
                        option={mapOptions(chartData)}
                        style={{ height: 400, width: '100%' }}
                     />
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default PDFCSS;
